import { render, staticRenderFns } from "./HomeOther.vue?vue&type=template&id=b619cdd0&"
import script from "./HomeOther.vue?vue&type=script&lang=js&"
export * from "./HomeOther.vue?vue&type=script&lang=js&"
import style0 from "./HomeOther.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports